module.exports = __webpack_public_path__ + "static/Soleil-00a1e55756ffb3ed6afe2c4dfc8deed0.otf";